__turbopack_context__.v({
  "Modal": "GBQoIG_Modal",
  "Modal--Alternative": "GBQoIG_Modal--Alternative",
  "Modal__Button": "GBQoIG_Modal__Button",
  "Modal__ButtonText": "GBQoIG_Modal__ButtonText",
  "Modal__Close": "GBQoIG_Modal__Close",
  "Modal__Content": "GBQoIG_Modal__Content",
  "Modal__Overlay": "GBQoIG_Modal__Overlay",
  "Modal__RichText": "GBQoIG_Modal__RichText",
  "show": "GBQoIG_show",
});
